const CLASE_BOTON =
  'rounded-lg border border-borde-fuerte bg-superficie px-3 py-2 font-medium text-tinta-2 transition-colors hover:bg-elevado disabled:cursor-not-allowed disabled:border-borde disabled:text-desactivado-tinta'

interface Props {
  pagina: number
  paginas: number
  onCambiar: (pagina: number) => void
  /** Nombre accesible de la barra; cámbialo si la pantalla tiene más de un listado. */
  etiqueta?: string
}

/**
 * La barra «Anterior · Página X de Y · Siguiente» de todos los listados. Con una
 * sola página no se pinta: no hay a dónde ir y solo quitaría sitio.
 */
export function BarraPaginacion({ pagina, paginas, onCambiar, etiqueta = 'Paginacion' }: Props) {
  if (paginas <= 1) return null
  return (
    <nav aria-label={etiqueta} className="flex items-center justify-between gap-3 text-sm">
      <button
        type="button"
        aria-label="Página anterior"
        disabled={pagina <= 1}
        onClick={() => onCambiar(pagina - 1)}
        className={CLASE_BOTON}
      >
        Anterior
      </button>
      <span className="text-tinta-apagada">
        Página {pagina} de {paginas}
      </span>
      <button
        type="button"
        aria-label="Página siguiente"
        disabled={pagina >= paginas}
        onClick={() => onCambiar(pagina + 1)}
        className={CLASE_BOTON}
      >
        Siguiente
      </button>
    </nav>
  )
}
